// import axios from 'axios'

import axios from "axios"

const getDefaultState = () => ({
    markBook: false,
    markBookPage: {},
    markBookAssesment: {},
    markRecord: {},
    spreadsheet: {},
    deleteAssesment: {},
    file: {},
})

export default{
    namespaced: true,

    state: getDefaultState(),

    getters: {
        getMarkBook (state) {
            return state.markBook
        },

        getMarkBookPage (state) {
            return state.markBookPage
        },

        getMarkRecord (state) {
            return state.markRecord
        },

        getMarkBookAssesment (state) {
            return state.markBookAssesment
        },

        getSpreadsheet (state) {
            return state.spreadsheet
        },

        getDeleteAssesment (state) {
            return state.deleteAssesment
        },

        getFile (state) {
            return state.file
        },
    },

    mutations: {
        resetState(state) {
            Object.assign(state, getDefaultState())  
        },

        setMarkBook (state, value) {
            state.markBook = value
        },

        setMarkBookPage (state, value) {
            state.markBookPage = value
        },

        setMarkRecord (state, value) {
            state.markRecord = value
        },

        setMarkBookAssesment (state, value) {
            state.markBookAssesment = value
        },

        setSpreadsheet (state, value) {
            state.spreadsheet = value
        }, 

        setDeleteAssesment (state, value) {
            state.deleteAssesment = value
        },

        setFile (state, value) {
            state.file = value
        },
       
    },

    actions: {
        getMarkBook ({ getters }) {
            let { 
                academic_year_id:year, 
                term, 
                subject_id:subjectId, 
                form_class_id:formClassId,
                form_level: form_level, 
                employee_id:employeeId,
                form_classes: form_classes, 
            } 
            = getters.getMarkBookPage;

            // console.log(getters.getMarkBookPage);

            let params = {
                academic_year_id: year,
                term,
                subject_id: subjectId,
                form_class_id: formClassId,
                form_level,
                employee_id: employeeId,
                form_classes
            }

            const url = '/api/mark-book'

            return axios.get(url, { params });
        },

        postMarkRecord ({ getters }) {
            const url = '/api/mark-book';
            return axios.post(url, getters.getMarkRecord);
        },

        postMarkBookAssesment ({ getters }) {
            const url = '/api/mark-book-assesment';
            console.log(getters.getMarkBookAssesment);
            return axios.post(url, getters.getMarkBookAssesment);
        },

        downloadExcelMarkBookPage ({ getters }) {
            let { 
                academic_year_id:year, 
                term, 
                subject_id:subjectId, 
                form_classes:formClasses,
                employee_id:employeeId 
            } 
            = getters.getMarkBookPage;
            console.log(getters.getMarkBookPage);

            const url = '/api/download-mark-book-page'

            return axios({
                method: 'get',
                url: url,
                params: {
                    year: year,
                    term,
                    subject_id: subjectId,
                    form_classes: formClasses,
                    employee_id: employeeId
                },
                responseType: 'arraybuffer',
            });
        },

        getSpreadsheet ({ getters }) {
            const url = '/api/spreadsheet'; 
            console.log(getters.getSpreadsheet);
            return axios({
                method: 'get',
                url: url,
                params: getters.getSpreadsheet,
                responseType: 'arraybuffer',
            });
        },

        postSpreadsheet ({ getters }) {
            const url = '/api/spreadsheet-download';
            return axios({
                method: 'post',
                url: url,
                responseType: 'arraybuffer',
                data: getters.getFile
            })
        },

        getAcademicTerms () {
            const url = '/api/academic-terms';
            return axios.get(url);
        },

        deleteCourseAssesment ({ getters }) {
            const url = '/api/delete-course-assesment'
            return axios.post(url, getters.getDeleteAssesment);
        }
    }
}